import ApiService from "@/core/services/api.service";
import { STATUS_CODE } from "@/core/config/constant";
import { SET_ERROR } from "@/core/services/store/auth.module";

const { AUTHENTICATE, ERROR_SERVER, SUCCESS, BAD_REQUEST } = STATUS_CODE;
// mutation types
export const ADD_BUSINESS = "addBusiness"
export const SET_STATUS = "SetStatus"
export const SET_ERROR_MESSAGE = "SetErrorMessage"
export const SET_TITLE = "setTitle"
export const SET_TITLE_BUSINESS = "setTitleBusiness"
export const SET_BUSINESS = "setBusiness"

export const SET_LIST_DASHBOARD = "setListDashboard"
export const GET_LIST_DASHBOARD = "getListDashboard"

const state = {
  errors: null,
  status: null,
  title: null,
  business: null,
  dashBoard: null
}

const getters = {
  BusinessStatus: state => state.status,
  BusinessErrors: state => state.errors,
  BusinessTitle: state => state.title,
  getBusiness: state => state.business,
  getDashBoard: state => state.dashBoard

}

const mutations = {
  [SET_STATUS](state, code) {
    state.status = code;
  },
  [SET_ERROR_MESSAGE](state, errors) {
    state.errors = errors
  },
  [SET_TITLE](state, title) {
    state.title = title
  },
  [SET_BUSINESS](state, business) {
    state.business = business
  },
  [SET_LIST_DASHBOARD](state, dashBoard) {
    state.dashBoard = dashBoard
  }
}

const actions = {
  async [ADD_BUSINESS](context, dataInsert) {
    context.commit(SET_STATUS, null)
    context.commit(SET_ERROR_MESSAGE, null)
    try {
      const response = await ApiService.post('business-manager/registration', dataInsert)
      if (response.data.code == SUCCESS) {
        context.commit(SET_STATUS, response.data.code)
      }

      if (response.data.code == BAD_REQUEST) {
        context.commit(SET_STATUS, response.data.code)
        context.commit(SET_ERROR_MESSAGE, response.data.data)
      }
    } catch (e) {
      if (e.response.data.code == ERROR_SERVER) {
        context.commit(SET_ERROR, e.response.data.message);
        throw e.response.data.message
      } else {
          throw e;
      }
    }
    
  },
  async [SET_TITLE_BUSINESS](context) {
    context.commit(SET_STATUS, null)
    context.commit(SET_ERROR_MESSAGE, null)
    try {
      const response = await ApiService.get('business-manager/get-business')
      if (response.data.data == null) {
        context.commit(SET_TITLE, '')
        context.commit(SET_BUSINESS, null)
      } else {
        if (response.data.code == SUCCESS) {
          context.commit(SET_TITLE, response.data.data.jigyo_name)
          context.commit(SET_BUSINESS, response.data.data)
        } 
        if (response.data.code == BAD_REQUEST) {
          context.commit(SET_STATUS, response.data.code)
          context.commit(SET_ERROR_MESSAGE, response.data.data)
        }
      }

    } catch (e) {
      if (e.response) {
        if (e.response.data.code == ERROR_SERVER) {
          context.commit(SET_ERROR, e.response.data.message);
          throw e.response.data.message
        } else {
          throw e;
        }
      }
    }
  },
  async [GET_LIST_DASHBOARD](context, tax_flag) {
    context.commit(SET_STATUS, null)
    context.commit(SET_ERROR_MESSAGE, null)
    try {
      const response = await ApiService.get(`business-manager/dashboard?tax_flag=${tax_flag}`)

      if (response.data.code == SUCCESS) {
        context.commit(SET_LIST_DASHBOARD, response.data.data)
      }
      if (response.data.code == BAD_REQUEST) {
        context.commit(SET_STATUS, response.data.code)
        context.commit(SET_ERROR_MESSAGE, response.data.data)
      }
    } catch (e) {
      if (e.response) {
        if (e.response.data.code == ERROR_SERVER) {
          context.commit(SET_ERROR, e.response.data.message);
          throw e.response.data.message
        } else {
          throw e;
        }
      }
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}